import React, { useState } from "react";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";

import styles from "./paymentNew.module.css";

import { useAlert } from "../../../../Context/AlertModalContext";
const PaymentCheckout = ({ product, priceId, clientSecret, validCoupon, onSuccess, onError, onResetPromocode, onPromoCodeValid }) => {
    const alert = useAlert();

    const stripe = useStripe();
    const elements = useElements();
    const [confirmPaymentLoading, setConfirmPaymentLoading] = useState(false);

    // State for billing address
    const [billingAddress, setBillingAddress] = useState({
        address: "",
        city: "",
        state: "",
        postal_code: "",
        country: "US", // Default country, adjust as needed
    });

    const removeCoupon = async () => {
        onResetPromocode();
        return alert.setModal({ show: true, message: "Coupon removed successfully.", title: "Success" });
    }

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setBillingAddress((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return alert.setModal({ show: true, message: "Stripe.js has not loaded yet. Please wait and try again.", title: "Error" });
        }

        const paymentElement = elements.getElement(PaymentElement);
        if (!paymentElement) {
            return alert.setModal({ show: true, message: "PaymentElement is not mounted. Please refresh and try again.", title: "Error" });
        }

        setConfirmPaymentLoading(true);

        try {
            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: window.location.origin,
                    payment_method_data: {
                        billing_details: {
                            address: {
                                line1: billingAddress.address,
                                city: billingAddress.city,
                                state: billingAddress.state,
                                postal_code: billingAddress.postal_code,
                                country: billingAddress.country,
                            },
                        },
                    },
                },
                redirect: "if_required",
            });
            if (error) {
                setConfirmPaymentLoading(false);
                onError(error);
                return alert.setModal({ show: true, message: error.message, title: "Error" });
            } else {
                onSuccess(paymentIntent, billingAddress);
            }
        } catch (error) {
            onError(error);
            setConfirmPaymentLoading(false);
            return alert.setModal({ show: true, message: error.message || "Something went wrong. Please try again.", title: "Error" });
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <h6 className="mb-3">Details</h6>
                <PaymentElement />

                <h6 className="mb-3 mt-3">Billing Address</h6>
                <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    className="form-control mb-3"
                    value={billingAddress.address}
                    onChange={handleAddressChange}
                    required
                />

                <input
                    type="text"
                    name="city"
                    placeholder="City"
                    className="form-control mb-3"
                    value={billingAddress.city}
                    onChange={handleAddressChange}
                    required
                />

                <div className="row">
                    <div className="col-md-6 mb-3">
                        <input
                            type="text"
                            name="state"
                            placeholder="State / Province"
                            className="form-control mb-3"
                            value={billingAddress.state}
                            onChange={handleAddressChange}
                            required
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <input
                            type="text"
                            name="postal_code"
                            placeholder="ZIP / Postal Code"
                            className="form-control mb-3"
                            value={billingAddress.postal_code}
                            onChange={handleAddressChange}
                            required
                        />
                    </div>
                </div>

                <p className={styles.Recurringbilling}>Recurring billing, cancel anytime.</p>
                <p className={styles.textmuted}>Your subscription will automatically renew for the same package length at the same price until you cancel in settings in your MTD account. By subscribing, you agree to our
                    <button
                        className={styles.termandconditons}
                        onClick={(e) => { e.preventDefault(); window.open("/termandconditions", "_blank"); }}
                        style={{ background: "none", border: "none", padding: 0, color: "inherit", textDecoration: "underline", cursor: "pointer", marginLeft: "4px" }}
                    >terms of service</button>.
                </p>
                <p className={styles.textmuted}>We like commitments. No refunds.</p>
                {/* 
                <PaymentPromo
                    product={product}
                    validCoupon={validCoupon}
                    onResetPromocode={onResetPromocode}
                    onPromoCodeValid={onPromoCodeValid}
                /> */}

                {validCoupon && (
                    <div className={styles.coupon_list}>
                        <span>Coupon: {validCoupon.id}</span>
                        <span
                            className={styles.icon}
                            onClick={removeCoupon}
                        >
                            <i className="bi bi-trash"></i>
                        </span>
                    </div>
                )}
                <div className={styles.subscribeButtonContainer}>
                    <button type="submit" className="global-next-btn" disabled={!stripe || confirmPaymentLoading}>
                        {confirmPaymentLoading ? "Processing..." : "Confirm purchase"}
                    </button>
                </div>
                <p className={styles.textmuted}>Billed in CAD. Other conversions are estimates only. Actual charge may vary based on exchange rates.</p>
            </form>
        </div>
    );
};

export default PaymentCheckout;